import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { fetchNavigation } from '../services/navigationService'

export const useNavigation = () => {
  const [navigation, setNavigation] = useState([])
  const [loading, setLoading] = useState(true)
  const { user } = useSelector((state) => state.auth)

  useEffect(() => {
    const loadNavigation = async () => {
      if (!user) {
        setNavigation([])
        setLoading(false)
        return
      }

      try {
        setLoading(true)
        const nav = await fetchNavigation()
        setNavigation(nav)
      } catch (error) {
        console.error('Error loading navigation:', error)
        setNavigation([])
      } finally {
        setLoading(false)
      }
    }

    loadNavigation()
  }, [user])

  return { navigation, loading }
}
